import LogoLoader from '../../Loader/LogoLoader';
import { Suspense } from 'react';

function withSuspense(WrappedComponent, useLogoLoader) {
	return <Suspense fallback={useLogoLoader ? <LogoLoader /> : ''}>{WrappedComponent}</Suspense>;
}
export default withSuspense;
